import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from './firebase/AuthProvider';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import './styles/app.css';
import './styles/manager.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>
);
